import axios from 'axios'
import { getHrAccessToken } from 'services/session/authSession'

const OPEN_API_BASE_URL = process.env.REACT_APP_OPEN_API_URL
const request = axios.create({
  baseURL: OPEN_API_BASE_URL,
  headers: {
    Accept: 'application/json',
  },
})

request.interceptors.request.use(
  async (config) => {
    const hr_access_token = getHrAccessToken()
    if (hr_access_token) {
      config.headers['Authorization'] = `Bearer ${hr_access_token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  (response) => response,

  (error) => {
    // If response data type is blob
    if (
      error.request.responseType === 'blob' &&
      error.response.data instanceof Blob &&
      error.response.data.type &&
      error.response.data.type.toLowerCase().indexOf('json') !== -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader()
        reader.onload = () => {
          error.response.data = JSON.parse(reader.result)
          resolve(Promise.reject(error))
        }

        reader.onerror = () => {
          reject(error)
        }

        reader.readAsText(error.response.data)
      })
    }

    if (error.response) {
      const { status } = error.response

      if (status === 401) {
        console.log('You dont have authorized to access this page')
      } else if (status === 403) {
        console.log('You dont have permissions to perform this task')
      } else if (status === 500) {
        console.log('Server Error')
      }

      return Promise.reject(error.response)
    }
  }
)

// export function getData(response) {
//   return response.data
// }

export default request
